import store from "../store/index.js"
import configdata from './config';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Qs from 'qs'
const fs = require('fs');
const md5Hex = require('md5-hex');

var random_char = function(n){
    var random_charset = [
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i',
        'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
    ];
    var res = "";
    for (var i = 0; i < n; i++) {
        var id = Math.ceil(Math.random() * 35);
        res += random_charset[id];
    }
    return res;
}

var request = {
	md5(str){
		return md5Hex(str);
	},
	parseToken(query){
		var token = decodeURIComponent(query.token || "");
		if (token && token != "" && typeof token == "string") {
			store.dispatch('user/setToken', token); // 保存用户信息
		}
		
	},
    config: function(name) {
        var info = null;
        if (name) {
            var name2 = name.split("."); //字符分割
            if (name2.length > 1) {
                info = configdata[name2[0]][name2[1]] || null;
            } else {
                info = configdata[name] || null;
            }
        }
        return info;
    },
    post: function(url, data, header) {
        header = header || "application/x-www-form-urlencoded; charset=UTF-8";
		if (url.indexOf("http")<0 ) {
			 url = this.config("APIHOST") + url;
		}
        return new Promise((succ, error) => {
            axios({
                transformRequest: [function(data) { //在请求之前对data传参进行格式转换
                    data = Qs.stringify(data)
                    return data
                }],
                method: 'POST',
                url: url,
                data: data,
                headers: {
                    'Content-Type': header
                }
            }).then(res => {
                succ.call(self, res.data)
            }).catch(err => {
                error.call(self, err)
            })
        })
    },
    get: function(url, header) {
        header = header || "application/x-www-form-urlencoded; charset=UTF-8";
        url = this.config("APIHOST") + url;

        return new Promise((succ, error) => {
            axios({
                method: 'GET',
                url: url,
                headers: {
                    'Content-Type': header
                }
            }).then(res => {
                succ.call(self, res.data)
            }).catch(err => {
                error.call(self, err)
            })
        })
    }
};



export default request;
